export default "__VITE_ASSET__49bc0d42__"